import { useDashboardContext } from 'context/dashboard/dashboard.context';

import { BillingCustomerTypeEnum } from '../api/billingcustomer.types';

export const useIsB2BCustomer = () => {
  const { customerType } = useDashboardContext();
  return customerType === BillingCustomerTypeEnum.BUSINESS;
};
